<template>
  <section class="guide border">
    <div class="container">
      <div class="container-info">
        <div class="info-area" v-html="data.area" />
        <div class="info-title" v-html="data.title" />
        <div class="info-text" v-html="data.text" />
      </div>

      <div class="guide-container">
        <div class="guide-item" v-for="(guide, index) in data.list" :key="index">
          <Select
            :data="guide.list"
            :result="data.result"
            :required="data.required"
            :image="guide.image"
            :imageMobile="guide.image_mobile"
            :title="guide.title"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["data"],
  components: {
    Select: () => import("./Select"),
  },
};
</script>

<style lang="scss" src="./Guide.scss" />